module.exports = __webpack_public_path__ + "resources/4ceca9b16de3f3089eb490977af7b391.woff";


//////////////////
// WEBPACK FOOTER
// ./resources/fonts/TradeGothic-Regular.woff
// module id = 245
// module chunks = 0